import { mockUsers } from "../../constants/mockdata";

const Promotions = () => (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 bg-white p-6 shadow-lg rounded-xl">
            <h2 className="text-xl font-bold text-gray-800">Compose Promotion Email</h2>
            <div className="mt-6 space-y-4">
                <div><label className="text-sm font-medium text-gray-700">Email Subject</label><input type="text" placeholder="e.g., A Special Weekend Offer Just For You!" className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500" /></div>
                <div><label className="text-sm font-medium text-gray-700">Email Body</label><div className="w-full mt-1 h-72 border rounded-lg p-4 bg-gray-50 flex items-center justify-center"><p className="text-gray-500">Rich Text Editor would be here.</p></div></div>
            </div>
        </div>
        <div className="bg-white p-6 shadow-lg rounded-xl h-fit">
            <h2 className="text-xl font-bold text-gray-800">Select Recipients</h2>
            <div className="mt-4 space-y-2 max-h-80 overflow-y-auto">
                {mockUsers.map(user => (<label key={user.id} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500" /><div><p className="text-sm font-medium text-gray-900">{user.name}</p><p className="text-xs text-gray-500">{user.email}</p></div></label>))}
            </div>
            <button className="w-full mt-6 bg-red-600 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-red-700 transition">Send Promotional Email</button>
        </div>
    </div>
);

export default Promotions;